export const SEASON_TABLE_NAME = 'falling_block_puzzle_season2' as const;
